import { useTranslation } from 'react-i18next';

import Banner from './Banner.jsx';
import { parseDate } from '../../../utils/helpers';

const DraftPrizeBanner = ({ prize }) => {
  const { t } = useTranslation('posts');
  const { campaignStartDate, campaignEndDate } = prize;
  const formattedStartDate = parseDate(campaignStartDate, '', 'MMMM dd');
  const formattedEndDate = parseDate(campaignEndDate, '', 'MMMM dd, yyyy');

  return (
    <Banner
      header={t('prizeBanner.prizeStarts')}
      description={t('prizeBanner.availableDates', {
        startDate: formattedStartDate,
        endDate: formattedEndDate,
      })}
      errors={t('prizeBanner.errors.earlySchedule')}
    />
  );
};

export default DraftPrizeBanner;
